import { useNavigate } from 'react-router-dom';
import { PageShell } from '../../components/layout/page/PageShell';
import { readLastScreen } from '../../hooks/useRememberLastScreen';

export function AccessDeniedPage() {
  const navigate = useNavigate();

  function handleGoHome(): void {
    const lastScreen = readLastScreen();
    if (lastScreen) {
      navigate(lastScreen, { state: { restoreLastScreen: true } });
      return;
    }

    navigate('/dashboard');
  }

  return (
    <PageShell className="flex min-h-[60vh] flex-col items-center justify-center text-center">
      <h1 className="erp-page-title">Acesso negado</h1>
      <p className="mt-3 max-w-md erp-page-description">
        Você não possui permissão para acessar esta área. Se acredita que isso é um erro, fale com um administrador.
      </p>
      <button type="button" className="erp-btn-primary" onClick={handleGoHome}>
        Voltar ao início
      </button>
    </PageShell>
  );
}
